<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.construction.drawings.other_drawings.title')" header-tag="h3" class="bg-default-card">
                    <data-table
                        v-if="tableLoaded"
                        :exportable="this.$store.getters.hasPermission(['project_drawing_other'], ['read'])" title=""
                        :rows="getData.rowData"
                        :columns="columndata"
                        :perPage="perPage"
                        :rowsCount="rowsCount"
                        :currentPage="currentPage"
                        :pageCount="pageCount"
                        @exportButtonClick="onExportButton"
                        @rowClickDelete="onDeleteRow"
                        @rowClickEdit="onEditRow"
                        @rowClickParts="onParts"
                        @rowClickRevision="onRevision"
                        @rowClickCheck="onClickCheck"
                        @changePage="changePage"
                        @searchEvent="searchEvent"
                        @orderByEvent="orderByEvent"
                    >
                    </data-table>

                    <b-btn class="btn btn-default mt-2 mr-2" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_drawing_other'], ['create'])"><i class="fa fa-plus-circle"></i> {{$t('general.construction.drawings.other_drawings.create_button')}}</b-btn>

                    <span v-if="this.$store.getters.hasPermission(['project_drawing_other'], ['create', 'update'])">
                        <label v-if="!this.$store.state.ajax_in_progress" class="btn btn-primary mt-3" @click="$refs.importExcel.value = ''">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.construction.drawings.other_drawings.import') }}</span>
                            <input type="file" name="file" style="display:none" ref="importExcel" @change="onImportButton($event.target.name, $event.target.files)" accept="application/*"/>
                        </label>
                        <label v-else class="btn btn-primary mt-3 disabled">
                            <span><i class="fa fa-upload mr-1"></i> {{ $t('general.ajax_in_progress_please_wait') }}</span>
                        </label>
                    </span>
                </b-card>

                <div class="row">
                    <div class="col-sm-12">
                        <span v-if="this.$store.getters.hasPermission(['project_revisions'], ['read']) && getData.rowData.length > 0">
                            <i class="fa fa-2x fa-list-alt text-info"></i> - {{$t('general.buttons.revision')}} &nbsp; &nbsp;
                        </span>
                        
                        <span v-if="this.$store.getters.hasPermission(['project_drawing_other_part_list'], ['read']) && getData.rowData.length > 0">
                            <i class="fa fa-2x fa-th-list"></i> - {{$t('general.buttons.parts')}} &nbsp; &nbsp;
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <b-modal ref="saveModal" :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" :title="actionTitle" size="lg" @ok="saveAction" @hidden="hidden" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_drawing_other'], ['update']))">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="item_number">{{ $t('table.item_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <autocomplete @search="onItemNoSearch" :options="currentItemNo" v-model="model.item_number"></autocomplete>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="item_code">{{ $t('table.item_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" id="item_code" name="item_code" class="form-control" v-model="model.item_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="item_name">{{ $t('table.item_name') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" id="item_name" name="item_name" class="form-control" v-model="model.item_name">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="drawing_number">{{ $t('table.drawing_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <autocomplete @search="onDrawingNoSearch" :options="currentDrawingNo" v-model="model.drawing_number"></autocomplete>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="drawing_name">{{ $t('table.drawing_name') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.drawing_name">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="delivery_date">{{ $t('table.delivery_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" name="delivery_date" id="delivery_date" v-model="model.delivery_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="erection_start_date">{{ $t('table.erection_start_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" name="erection_start_date" id="erection_start_date" v-model="model.start_date"></flat-pickr>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="erection_end_date">{{ $t('table.erection_end_date') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <flat-pickr :config="{enableTime: false, inline: false}" class="form-control bg-white" name="erection_end_date" id="erection_end_date" v-model="model.end_date"></flat-pickr>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="work_type">{{ $t('table.work_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedWorkType"
                                :options="currentWorkType"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isWorkTypeLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="value" track-by="id"
                                :selectLabel="''"
                                @search-change="onWorkTypeSearch"
                                @input="updateWorkType"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWorkType != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWorkType"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="remark">{{$t('table.remark')}}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="model.remark"></textarea>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="priority">{{ $t('table.priority') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.priority">
                                <option v-for="priority in drawing_priority" :value="priority.name">{{priority.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.delayed') }}</label>
                        </div>
                        <div class="col-lg-8" style="z-index: 0;">
                            <toggle-button v-model="model.delayed" :sync="true" :value="false" :color="{checked: '#ff471a'}" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" disabled/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="test_type">{{ $t('table.test_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.test_type">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="ped_category">{{ $t('table.ped_category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.ped_category">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="materials">{{ $t('table.materials') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.materials">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="progress_status">{{ $t('table.progress_status') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select v-model="model.progress_status" class="form-control">
                                <option v-for="i in (1, 100)" :key="i" :value="i">
                                    {{ i }} %
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="weight">{{ $t('table.weight') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" id="weight" name="weight" class="form-control" v-model="model.weight">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="authorization_authority">{{ $t('table.authorization_authority') }}</label>
                        </div>
                        <div class="col-lg-8 mt-2">
                            <toggle-button v-model="model.authorization_authority" id="authorization_authority" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="ex_category">{{ $t('table.ex_category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.ex_category" id="ex_category" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.ex_category == 1">
                        <div class="col-lg-4">
                            <label for="category">{{ $t('table.category') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.category">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.estimated_working_hours') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.estimated_working_hours">
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.real_needed_hours') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input disabled type="text" class="form-control" v-model="model.real_needed_hours">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="field_area">{{ $t('table.field_area') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.field_area">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="heat_treatment">{{ $t('table.heat_treatment') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.heat_treatment" id="heat_treatment" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="special_coating">{{ $t('table.special_coating') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.special_coating" id="special_coating" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="insulation">{{ $t('table.insulation') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.insulation" id="insulation" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="thickness">{{ $t('table.thickness') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" id="thickness" name="thickness" class="form-control" v-model="model.thickness">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="insulation_type">{{ $t('table.insulation_type') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="model.insulation_type">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="painting">{{ $t('table.painting') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.painting" id="painting" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.painting == 1">
                        <div class="col-lg-4">
                            <label for="painting_code">{{ $t('table.painting_code') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" id="painting_code" name="painting_code" class="form-control" v-model="model.painting_code">
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('table.working_group') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedWorkingGroup"
                                :options="currentWorkingGroup"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isWorkingGroupLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="name" track-by="id"
                                :selectLabel="''"
                                @search-change="onWorkingGroupSearch"
                                @input="updateWorkingGroup"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedWorkingGroup != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedWorkingGroup "
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="model.working_group_id != null">
                        <div class="col-lg-4">
                            <label>{{ $t('table.team_member') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <multiselect v-model="selectedUser"
                                :options="currentUser"
                                :multiple="false"
                                :clear-on-select="true"
                                :hide-selected="false"
                                :loading="isUserLoading"
                                :preserve-search="true"
                                placeholder=""
                                label="fullname" track-by="id"
                                :selectLabel="''"
                                @search-change="onUserSearch"
                                @input="updateUser"
                            >
                                <template slot="clear" slot-scope="props">
                                    <div 
                                        v-if="selectedUser != null" 
                                        class="multiselect__clear" 
                                        @mousedown.prevent.stop="clearSelectedUser"
                                    >
                                    </div>
                                </template>
                                <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                                <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="heat_tracing">{{ $t('table.heat_tracing') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <select class="form-control" v-model="model.heat_tracing">
                                <option v-for="heat in heat_tracing" :value="heat.code">{{heat.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label for="scaffolding">{{ $t('table.scaffolding') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <toggle-button v-model="model.scaffolding" id="scaffolding" :sync="true" :value="false" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}"/>
                        </div>
                    </div>

                    <div class="row mb-3" v-if="row">
                        <div class="col-lg-4">
                            <label>{{ $t('table.revision_number') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input class="form-control" type="text" disabled v-model="model.revision_number"/>
                        </div>
                    </div>
                </div>
            </div>

            <hr v-if="(getData.getFiles.length > 0 && hasFilesReadPermission) || hasFilesCreatePermission">
            <div class="row mt-2" v-if="getData.getFiles.length > 0 && hasFilesReadPermission">
                <div class="col-lg-12">
                    <label>{{ $t('table.uploaded_files') }}</label>
                </div>
                <div class="col-lg-6" v-for="file in getData.getFiles" :key="file.id">
                    <div class="card p-2">
                        <div style="width: 100%; display: block">
                            <p 
                                class="float-left customLink" 
                                @click="onDownloadFile(file.id)" 
                                :title="file.file_name"
                            >
                                {{file.file_name}}
                            </p>
                            <p 
                                v-if="hasFilesDeletePermission"
                                class="float-right p-0 m-0"
                            >
                                <i class='fa fa-2x fa-trash mt-2 text-danger sortable cursor-pointer' @click="onDeleteFile(file.id)"></i>
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-2" v-if="hasFilesCreatePermission">
                <div class="col-lg-12">
                    <div class="row mb-3">
                        <div class="col-lg-12">
                            <label v-if="row && getData.getFiles.length > 0">{{ $t('table.upload_more_files') }}</label>
                            <label v-else>{{ $t('table.upload_files') }}</label>
                        </div>
                        <div class="col-lg-12">
                            <vue-dropzone class="dropzone" ref="document" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
                        </div>
                    </div>
                </div>
            </div>
            <hr v-if="row">

            <div v-if="row">
                <div class="row">
                    <div class="col-lg-3">
                        <label for="connected_drawings">{{ $t('table.connected_drawings') }}</label>
                    </div>
                    <div class="col-lg-12">
                        <multiselect v-model="selectedDrawing"
                            :options="currentDrawing"
                            :multiple="true"
                            :clear-on-select="true"
                            :hide-selected="false"
                            :loading="isDrawingLoading"
                            :preserve-search="true"
                            placeholder=""
                            label="info" track-by="id"
                            :preselect-first="false"
                            :selectLabel="''"
                            @search-change="onDrawingSearch"
                            @input="updateDrawing"
                        >
                            <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                            <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                        </multiselect>
                    </div>
                </div>

                <hr>
                <h3>{{ $t('table.line') }}</h3>
                <data-table
                    :exportable="false" 
                    :search="false" 
                    title=""
                    :rows="getData.lineData"
                    :columns="lineColumnData"
                    @rowClickDelete="onDeleteLineRow"
                    :paginate="false" 
                >
                </data-table>
                <i class="btn pull-right mt-2 fa fa-plus-square fa-2x" style="padding: 0 0 5px 0;" @click="onAddLine"></i>
            </div>
        </b-modal>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="addLineModal" :title="actionTitle" size="md" @ok="saveLineAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_line'], ['create']))" @hidden="onEditRow(row)">
            <div class="row">
                <div class="col-lg-3">
                    <label>{{ $t('table.line') }}</label>
                </div>
                <div class="col-lg-9">
                    <multiselect v-model="selectedLine"
                        :options="currentLine"
                        :multiple="false"
                        :clear-on-select="true"
                        :hide-selected="false"
                        :loading="isLineLoading"
                        :preserve-search="true"
                        placeholder=""
                        label="line_number" track-by="id"
                        :selectLabel="''"
                        @search-change="onLineSearch"
                    >
                        <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                        <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                    </multiselect>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitleDelete" @buttonClick="deleteAction">
            {{ delete_message }}
        </confirm-dialog>

        <confirm-dialog ref="deleteLineModal" :title="actionTitle" @buttonClick="deleteLineAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
import http from '@/libs/http';
import miniToastr from 'mini-toastr';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import Autocomplete from '@/components/global/miscellaneous/Autocomplete.vue';

import Multiselect from 'vue-multiselect';

import vue2Dropzone from 'vue2-dropzone';
import '@/assets/css/vue2Dropzone.css';

export default {
    name: 'other_drawings',
    components: {
        DataTable,
        flatPickr,
        ConfirmDialog,
        notificationIcons,
        Multiselect,
        Autocomplete,
        vueDropzone: vue2Dropzone,
    },
    data () {
        return {
            breadcrumbItems: [
                {
                    text: Vue.i18n.translate('general.dashboard.title'),
                    to: '/',
                },
                {
                    text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                    to: '/project/'+this.$route.params.id,
                },
                {
                    text: Vue.i18n.translate('general.construction.title'),
                    active: true
                },
                {
                    text: Vue.i18n.translate('general.construction.drawings.other_drawings.title'),
                    active: true
                }
            ],
            tableName: 'drawing',
            tableNameTranslated: Vue.i18n.translate('general.construction.drawings.other_drawings.title_modal'),
            row: null,
            rowLine: '',
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',
            actionTitleDelete: '',
            delete_message: '',

            //check if already opened
            already_opened_warning: false,
            //end check if already opened

            selectedWorkType: null,
            currentWorkType: [],
            isWorkTypeLoading: false,

            selectedWorkingGroup: null,
            currentWorkingGroup: [],
            isWorkingGroupLoading: false,

            selectedUser: null,
            currentUser: [],
            isUserLoading: false,

            currentDrawingNo: [],
            currentItemNo: [],
            
            selectedDrawing: null,
            currentDrawing: [],
            isDrawingLoading: false,

            selectedLine: null,
            currentLine: [],
            isLineLoading: false,

            file_id: null,
            isFileDelete: false,

            hasFilesReadPermission: false,
            hasFilesCreatePermission: false,
            hasFilesDeletePermission: false,

            dropzoneOptions: {
                url: '/',
                thumbnailWidth: 150,
                addRemoveLinks: true,
                autoProcessQueue: false,
                uploadMultiple: true,
                dictDefaultMessage: '<i class="fa fa-cloud-upload"></i>' + ' ' + Vue.i18n.translate('table.upload_files'),
                maxFiles: 3,
            },
            getData: {
                rowData: [],
                getFiles: [],
                lineData: [],
            },
            model: {
                file: null,
                line_id: null,
                project_id: null,
                item_number: null,
                revision_number: null,
                discipline_id: null,
                part_number: null,
                part_code: null,
                part_name: null,
                line_number: null,
                equipment_number: null,
                drawing_number: null,
                drawing_name: null,
                delivery_date: null,
                start_date: null,
                end_date: null,
                work_type_id: null,
                remark: null,
                priority: null,
                delayed: null,
                test_type: null,
                ped_category: null,
                materials: null,
                project_setting_id: null,
                authorization_authority: null,
                weight: null,
                ex_category: null,
                category: null,
                estimated_working_hours: null,
                real_needed_hours: null,
                field_area: null,
                heat_treatment: null,
                special_coating: null,
                insulation: null,
                thickness: null,
                insulation_type: null,
                painting: null,
                painting_code: null,
                working_group_id: null,
                user_id: null,
                heat_tracing: null,
                scaffolding: null,
                delayed: null,
                progress_status: null
            },
            columndata: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    showDeleteButton: true,
                    showEditButton: true,
                    showPartsButton: true,
                    showRevisionButton: true,
                    forceShowRequestButton: false,
                    width: '170px'
                },
                {
                    label: Vue.i18n.translate('table.revision_date'),
                    field: 'revision_date',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.revision_number'),
                    field: 'revision_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.drawing_number'),
                    field: 'drawing_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.drawing_name'),
                    field: 'drawing_name',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.item_number'),
                    field: 'item_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.item_code'),
                    field: 'item_code',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.start_date'),
                    width: '105px',
                    field: 'start_date',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.end_date'),
                    width: '105px',
                    field: 'end_date',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.priority'),
                    field: 'priority',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.delayed'),
                    field: 'delayed',
                    numeric: false,
                    html: false,
                    showAsCheckRed: true
                }, {
                    label: Vue.i18n.translate('table.field_area'),
                    field: 'field_area',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.working_group'),
                    field: 'working_group.name',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.work_type'),
                    field: 'work_type.key',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.test_type'),
                    field: 'test_type',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.weight'),
                    field: 'weight',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.heat_treatment'),
                    field: 'heat_treatment',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                }, {
                    label: Vue.i18n.translate('table.special_coating'),
                    field: 'special_coating',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                }, {
                    label: Vue.i18n.translate('table.insulation'),
                    field: 'insulation',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                }, {
                    label: Vue.i18n.translate('table.painting'),
                    field: 'painting',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                }, {
                    label: Vue.i18n.translate('table.heat_tracing'),
                    field: 'heat_tracingV',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.scaffolding'),
                    field: 'scaffolding',
                    numeric: false,
                    html: false,
                    showAsCheck: true
                }, {
                    label: Vue.i18n.translate('table.progress_status'),
                    field: 'progress_status',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.estimated_working_hours'),
                    field: 'estimated_working_hours',
                    numeric: false,
                    html: false,
                }, {
                    label: Vue.i18n.translate('table.real_needed_hours'),
                    field: 'real_needed_hours',
                    numeric: false,
                    html: false,
                }
            ],
            lineColumnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '45px',
                    showDeleteButton: true,
                },
                {
                    label: Vue.i18n.translate('table.line_no'),
                    field: 'line_number',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.test_circuit_no'),
                    field: 'test_circuit_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.tie_in_no'),
                    field: 'tie_in_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.location_from'),
                    field: 'location_from',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.location_to'),
                    field: 'location_to',
                    numeric: false,
                    html: false,
                }
            ],
            
        }
    },
    mounted() {
        this.hasFilesReadPermission   = this.$store.getters.hasPermission(['files'], ['read']);
        this.hasFilesCreatePermission = this.$store.getters.hasPermission(['files'], ['create']);
        this.hasFilesDeletePermission = this.$store.getters.hasPermission(['files'], ['delete']);
    },
    computed: {
        heat_tracing: {
            get () {
                let heat_tracing = this.$store.getters.getHeatTracing;
                return heat_tracing;
            }
        },
        drawing_priority: {
            get: function () {
                let drawing_priority = this.$store.getters.getDrawingPriority;
                return drawing_priority;
            }
        },
        default_disciplines: {
            get: function () {
                return this.$store.getters.getDefaultDisciplines;
            }
        }
    },
    watch: {
        heat_tracing: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        drawing_priority: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
            }
        },
        default_disciplines: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                if(newVal != oldVal && typeof newVal != 'undefined' && newVal != null) {
                    this.onLoadTable(newVal.OtherWorks);
                }
            }
        },
        model: {
            immediate: true,
            deep: true,
            handler(newVal, oldVal) {
                this.model.authorization_authority  = Boolean(newVal.authorization_authority);
                this.model.ex_category              = Boolean(newVal.ex_category);
                this.model.heat_treatment           = Boolean(newVal.heat_treatment);
                this.model.special_coating          = Boolean(newVal.special_coating);
                this.model.painting                 = Boolean(newVal.painting);
                this.model.scaffolding              = Boolean(newVal.scaffolding);
            }
        }
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        warnMsg(msg) {
            miniToastr.warn(msg, Vue.i18n.translate('messages.warn'), 6000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable()
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable (discipline_id=null) {
            if (discipline_id == null) {
                discipline_id = this.default_disciplines.OtherWorks;
            }

            http.route(this.tableName + '?project_id='+this.$route.params.id+'&filters[parent_drawing_id]=null&filters[discipline_id]=' + discipline_id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get().then(response => {
                if (!response.isError) {
                    this.perPage = response.pagination.limit;
                    this.rowsCount = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount = response.pagination.totalPages;
                    var data = response.data;
                    data.forEach(field => {
                        if (field.work_type == null) {
                            field.work_type = { 'value': '' }
                        }

                        if (field.working_group == null) {
                            field.working_group = { 'name': '' }
                        }

                        if (typeof this.heat_tracing[field.heat_tracing] != 'undefined') {
                            field.heat_tracingV = this.heat_tracing[field.heat_tracing].name;
                        }
                    });
                    this.getData.rowData = data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        clearSearches () {
            this.selectedWorkType     = null;
            this.selectedWorkingGroup = null;
            this.selectedUser         = null;
            this.selectedDrawing      = null;
            this.selectedLine         = null;

            this.currentWorkType     = [];
            this.currentWorkingGroup = [];
            this.currentUser         = [];
            this.currentDrawing      = [];
            this.currentLine         = [];

            this.getData.getFiles = [];
            this.$nextTick(() => {
                if (typeof this.$refs.document != 'undefined') {
                    this.$refs.document.removeAllFiles();
                }
            });
        },
        onAddRow () {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
            this.row = null;
            this.clearSearches();

            this.model.revision_number = null;
            this.model.line_id = null;
            this.model.project_id = null;
            this.model.discipline_id = null;
            this.model.item_number = null;
            this.model.item_code = null;
            this.model.item_name = null;
            this.model.part_number = null;
            this.model.part_code = null;
            this.model.part_name = null;
            this.model.equipment_number = null;
            this.model.line_number = null;
            this.model.drawing_number = null;
            this.model.drawing_name = null;
            this.model.delivery_date = null;
            this.model.start_date = null;
            this.model.end_date = null;
            this.model.work_type_id = null;
            this.model.remark = null;
            this.model.priority = null;
            this.model.delayed = null;
            this.model.test_type = null;
            this.model.ped_category = null;
            this.model.materials = null;
            this.model.project_setting_id = null;
            this.model.authorization_authority = null;
            this.model.weight = null;
            this.model.ex_category = null;
            this.model.category = null;
            this.model.estimated_working_hours = null;
            this.model.real_needed_hours = null;
            this.model.field_area = null;
            this.model.heat_treatment = null;
            this.model.special_coating = null;
            this.model.insulation = null;
            this.model.thickness = null;
            this.model.insulation_type = null;
            this.model.painting = null;
            this.model.painting_code = null;
            this.model.working_group_id = null;
            this.model.user_id = null;
            this.model.heat_tracing = null;
            this.model.scaffolding = null;
            this.model.progress_status = null;

            this.$refs.saveModal.show();
        },
        onEditRow (row) {
            this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.clearSearches();
            this.loadLines();

            if (this.hasFilesReadPermission) {
                this.onViewFiles(row.id);
            }

            //check if already opened
            this.already_opened_warning = false;
            let data = {
                id: this.row.id,
                object_is_opened_now: 1,
            };
            http.route(this.tableName + '/' + this.row.id).patch(data, true).then(response => {
                if (response.isError == false) {
                    if (typeof response.data != 'undefined') {
                        if (response.data.opened_by != this.$store.state.user.user.id) {
                            this.warnMsg(Vue.i18n.translate('misc.document_is_open'));                      
                        }
                    }
                }
            });
            //end check if already opened

            this.model.line_id = this.row.line_id;
            this.model.project_id = this.row.project_id;
            this.model.discipline_id = this.row.discipline_id;
            this.model.item_number = this.row.item_number;
            this.model.item_code = this.row.item_code;
            this.model.item_name = this.row.item_name;
            this.model.part_number = this.row.part_number;
            this.model.part_code = this.row.part_code;
            this.model.part_name = this.row.part_name;
            this.model.equipment_number = this.row.equipment_number;
            this.model.line_number = this.row.line_number;
            this.model.drawing_number = this.row.drawing_number;
            this.model.drawing_name = this.row.drawing_name;
            this.model.delivery_date = this.row.delivery_date;
            this.model.start_date = this.row.start_date;
            this.model.end_date = this.row.end_date;
            this.model.work_type_id = this.row.work_type_id;
            this.model.remark = this.row.remark;
            this.model.priority = this.row.priority;
            this.model.delayed = this.row.delayed;
            this.model.test_type = this.row.test_type;
            this.model.ped_category = this.row.ped_category;
            this.model.materials = this.row.materials;
            this.model.project_setting_id = this.row.project_setting_id;
            this.model.authorization_authority = Boolean(this.row.authorization_authority);
            this.model.weight = this.row.weight;
            this.model.ex_category = Boolean(this.row.ex_category);
            this.model.category = this.row.category;
            this.model.estimated_working_hours = this.row.estimated_working_hours;
            this.model.real_needed_hours = this.row.real_needed_hours;
            this.model.field_area = this.row.field_area;
            this.model.heat_treatment = Boolean(this.row.heat_treatment);
            this.model.special_coating = Boolean(this.row.special_coating);
            this.model.insulation = Boolean(this.row.insulation);
            this.model.thickness = this.row.thickness;
            this.model.insulation_type = this.row.insulation_type;
            this.model.painting = Boolean(this.row.painting);
            this.model.painting_code = this.row.painting_code;
            this.model.working_group_id = this.row.working_group_id;
            this.model.user_id = this.row.user_id;
            this.model.heat_tracing = this.row.heat_tracing;
            this.model.scaffolding = Boolean(this.row.scaffolding);
            this.model.progress_status = this.row.progress_status;
            this.model.revision_number = this.row.revision_number;

            this.selectedWorkType     = (row.work_type != null && typeof row.work_type.value != 'undefined' && row.work_type.value != '') ? row.work_type : null;
            this.selectedWorkingGroup = (row.working_group != null && typeof row.working_group.name != 'undefined' && row.working_group.name != '') ? row.working_group : null;
            this.selectedUser         = row.user;
            this.selectedDrawing      = row.connected_drawings;
            this.selectedLine         = row.line;

            this.$refs.saveModal.show();
        },
        saveAction (e) {
            e.preventDefault();

            let put_data = {
                line_id: this.model.line_id,
                project_id: this.$route.params.id,
                discipline_id: this.default_disciplines.OtherWorks,
                item_number: this.model.item_number,
                item_code: this.model.item_code,
                item_name: this.model.item_name,
                part_number: this.model.part_number,
                part_code: this.model.part_code,
                part_name: this.model.part_name,
                equipment_number: this.model.equipment_number,
                drawing_number: this.model.drawing_number,
                drawing_name: this.model.drawing_name,
                delivery_date: this.model.delivery_date,
                start_date: this.model.start_date,
                end_date: this.model.end_date,
                work_type_id: this.model.work_type_id,
                remark: this.model.remark,
                priority: this.model.priority,
                test_type: this.model.test_type,
                ped_category: this.model.ped_category,
                materials: this.model.materials,
                project_setting_id: this.model.project_setting_id,
                authorization_authority: this.model.authorization_authority,
                weight: this.model.weight,
                ex_category: this.model.ex_category,
                category: this.model.category,
                field_area: this.model.field_area,
                heat_treatment: this.model.heat_treatment,
                special_coating: this.model.special_coating,
                insulation: this.model.insulation,
                thickness: this.model.thickness,
                insulation_type: this.model.insulation_type,
                painting: this.model.painting,
                painting_code: this.model.painting_code,
                working_group_id: this.model.working_group_id,
                user_id: this.model.user_id,
                heat_tracing: this.model.heat_tracing,
                scaffolding: this.model.scaffolding,
                progress_status: this.model.progress_status
            }

            Object.keys(put_data).forEach(key => {
                if (put_data[key] === '') {
                    put_data[key] = null;
                }
            });

            if (this.row) {
                put_data['connected_drawings'] = [];

                this.selectedDrawing.forEach(drawing => {
                    put_data['connected_drawings'].push(drawing.id);
                });

                //check if already opened
                put_data['already_opened_warning'] = this.already_opened_warning;
                //end check if already opened

                http.route(this.tableName + '/' + this.row.id).patch(put_data, true).then(response => {
                    if (!response.isError) {
                        this.uploadDocuments(this.row.id);
                        this.$refs.saveModal.hide();
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));

                        //check if already opened
                        this.already_opened_warning = false;
                        //end check if already opened
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            //check if already opened
                            if (response.errorMessage[key] == 'misc.document_already_opened') {
                                this.already_opened_warning = true;
                            this.errorMsg(Vue.i18n.translate('misc.document_already_opened'));
                            } else {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            }
                            //end check if already opened
                        });
                    }
                });
            } else {
                let data = http.route(this.tableName).post(put_data, true);
                data.then(response => {
                    if(response.isError) {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    } else {
                        this.uploadDocuments(response.data.id);
                        this.$refs.saveModal.hide();
                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                    }
                });
            }
        },
        uploadDocuments (id) {
            if (this.hasFilesCreatePermission && typeof this.$refs.document != 'undefined') { 
                var file = this.$refs.document.getQueuedFiles();
                for (let order = 0; order < file.length; order++) {
                    var formData = new FormData();
                    formData.append('file', file[order]);
                    formData.append('type', 'drawing');
                    formData.append('drawing_id', id);
                    let data = http.route('file').post(
                        formData,
                            {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    ).then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.successMsg(Vue.i18n.translate('messages.file_uploaded'));
                            this.onLoadTable();
                        }
                    });
                }
            }
        },
        onViewFiles (id) {
            this.getData.getFiles.length = 0;
            let data = http.route('file?get_all=1&filters[drawing_id]=' + id).get();
            data.then(response => {
                if(response.data == false) {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                } else {
                    this.getData.getFiles = response.data;
                }
            });
        },
        onDownloadFile (id) {
            let data = http.route('file/' + id).get(
            {
                export_pdf: 1
            }, true);
            data.then(response => {
                if (!response.isError) {
                    this.successMsg(Vue.i18n.translate('messages.file.file_download'));
                    let data = http.route('get_content/file/'+response.data.id+'/'+response.data.file_name).downloadPdf({}, response.data.file_name).then(res => {});
                } else {
                    this.errorMsg(Vue.i18n.translate('messages.file.error_download'));
                }
            });
        },
        onDeleteRow (row) {
            this.actionTitleDelete = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.delete_message = Vue.i18n.translate('messages.delete');
            this.row = row;
            this.file_id = null;
            this.isFileDelete = false;
            this.$refs.deleteModal.show();
        },
        onDeleteFile (id) {
            this.actionTitleDelete = Vue.i18n.translate('messages.delete_file_title');
            this.delete_message = Vue.i18n.translate('messages.delete_file');
            this.file_id = id;
            this.isFileDelete = true;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                if (this.isFileDelete == true) {
                    let data = http.route('file/' + this.file_id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            this.onLoadTable();
                            this.successMsg(Vue.i18n.translate('messages.deleted_file_message'));
                            this.file_id = null;
                            this.$refs.saveModal.hide();
                        } else {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        }
                    });
                } else if (this.isFileDelete == false) {
                    let data = http.route(this.tableName + '/' + this.row.id).delete();
                    data.then(response => {
                        if (!response.isError) {
                            if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                                this.currentPage = this.currentPage - 1;
                            }

                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
            }
            this.$refs.deleteModal.hide();
        },
        hidden(e) {
            //check if already opened
            this.already_opened_warning = false;
            if (this.row != null) {
                let data = {
                    id: this.row.id,
                    object_is_opened_now: 0,
                };
                http.route(this.tableName + '/' + this.row.id).patch(data, true);
            }
            //end check if already opened
        },
        onParts (row) {
            this.$router.push({name: 'other_drawings_parts', params: {id:this.$route.params.id, id2: row.id}});
        },
        onRevision (row) {
            this.$router.push({name: 'other_drawings_revisioncontrol', params: {id:this.$route.params.id, id2: row.id}});
        },
        onClickCheck (row, index, column) {
            if (row) {
                if(column == 'delayed') {
                    if(row.delayed == true && row.delay != null) {
                        http.route('delay/'+row.delay.id).patch({
                            end_date: new Date().toISOString().slice(0, 19).replace('T', ' '),
                            title: row.delay.title,
                            delay_date: row.delay.delay_date,
                            discipline_id: row.delay.discipline_id
                        }, true).then(response => {
                            if(!response.data) {
                                Object.keys(response.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                                });
                            } else {
                                this.onLoadTable();
                                this.successMsg(Vue.i18n.translate('messages.delay_updated'));
                            }
                        });
                    } else {
                        this.$router.push({name: 'delays'});
                    }
                } else {
                    this.model[column.toString()] = (row[column.toString()] == null || row[column.toString()] == 0) ? 1 : 0;

                    var clone = Object.assign({}, row);
                    clone[column.toString()] = !clone[column.toString()];

                    let data = http.route(this.tableName + '/' + row.id).patch(clone, true);
                    data.then(response => {
                        if(response.data == false) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            row[column.toString()] = !row[column.toString()];
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                        }
                    });
                    this.model[column.toString()] = null;
                }
            }
        },
        onExportButton() {
            http.route(this.tableName + '?filters[discipline_id]=' + this.default_disciplines.OtherWorks + '&project_id=' + this.$route.params.id).exportExcel({
                export: 'other',
                search: this.searchInput,
                sort_by: this.sortBy,
                sort_order: this.sortType
            }, 'other_drawings.xlsx').then(response => {
                if (typeof response != 'undefined') {
                    this.errorMsg(Vue.i18n.translate('errors.error_export'));
                } else {
                    this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.exported'));
                }
            });
        },
        onImportButton(fieldName, fileList) {
            const formData = new FormData();

            if (!fileList.length) return;

            formData.append('project_id', this.$route.params.id);
            formData.append('type', 'other');

            Array
            .from(Array(fileList.length).keys())
            .map(x => {
                formData.append(fieldName, fileList[x], fileList[x].name);
            });

            http.route('drawing/import').importExcel(formData)
            .then(response => {
                if (response.isError) {
                Object.keys(response.errorMessage).forEach(key => {
                    this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                });
            } else {
                this.onLoadTable();
                this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.imported'));
            }
            });
        },
        //Lines
        loadLines() {
            http.route('drawing/' + this.row.id + '/line').get().then(response => {
                if (!response.isError) {
                    var data = response.data;
                    data.forEach((field, key) => {
                        if (field.tie_in == null) {
                            field.tie_in = { 'tie_in_nr': '' }
                        }
                    });

                    this.getData.lineData = data;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        saveLineAction(e) {
            e.preventDefault();

            if (this.selectedLine == null) {
                this.errorMsg(Vue.i18n.translate('errors.line.required'));

                return 0;
            }
            
            http.route('drawing/' + this.row.id + '/line').post({
                line_id: this.selectedLine.id,
            }, true).then(response => {
                if (!response.isError) {
                    this.onEditRow(this.row);
                    this.successMsg(Vue.i18n.translate('general.line_list.title_modal') + ' ' + Vue.i18n.translate('messages.created'));
                    this.$refs.addLineModal.hide();
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onAddLine() {
            this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + Vue.i18n.translate('general.line_list.title');
            this.selectedLine = null;
            this.$refs.addLineModal.show();
        },
        onDeleteLineRow(row) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + Vue.i18n.translate('general.line_list.title_modal')
            this.rowLine = row;
            this.$refs.deleteLineModal.show();
        },
        deleteLineAction(button) {
            if(button == 1) {
                http.route('drawing/' + this.row.id + '/line/' + this.rowLine.id).delete().then(response => {
                    if (!response.isError) {
                        this.onEditRow(this.row);
                        this.successMsg(Vue.i18n.translate('general.line_list.title_modal') + ' ' + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        this.onEditRow(this.row);
                    }
                });
            } else {
                this.onEditRow(this.row);
            }

            this.$refs.deleteLineModal.hide();
        },
        onWorkTypeSearch(search) {
            if (search == '') {
                this.currentWorkType = [];
                
                return false;
            }

            this.isWorkTypeLoading = true;
            this.searchWorkType(search, this);
        },
        searchWorkType: _.debounce((search, vm) => {
            http.route("projectsetting?project_id="+vm.$route.params.id+"&filters[type]=work_type&get_all=1&search_select=" + search).get()
            .then(response => {
                if (response.data != false) {
                    vm.currentWorkType = response.data;
                }
                vm.isWorkTypeLoading = false;
            });
        }, 500),
        updateWorkType(work_type) {
            this.model.work_type_id = (work_type != null) ? work_type.id : null;
        },
        clearSelectedWorkType () {
            this.selectedWorkType   = null;
            this.model.work_type_id = null;
        },
        onWorkingGroupSearch(search) {
            if (search == '') {
                this.currentWorkingGroup = [];
                
                return false;
            }

            this.isWorkingGroupLoading = true;
            this.searchWorkingGroup(search, this, this.$route.params.id);
        },
        searchWorkingGroup: _.debounce((search, vm, project_id) => {
            let data = http.route('team?project_id='+ project_id +'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentWorkingGroup = response.data;
                }
                vm.isWorkingGroupLoading = false;
            });
        }, 500),
        updateWorkingGroup(working_group) {
            this.currentUser  = [];
            this.clearSelectedUser();
            this.model.working_group_id = (working_group != null) ? working_group.id : null;

            if (working_group != null) {
                http.route('team/' + working_group.id +'/members?project_id='+this.$route.params.id).get().then(response => {
                    if (response.data != false) {
                        this.selectedUser = null;
                        this.currentUser = response.data;
                    }
                });
            }
        },
        clearSelectedWorkingGroup () {
            this.selectedWorkingGroup   = null;
            this.model.working_group_id = null;
            this.clearSelectedUser();
        },
        onUserSearch(search) {
            if (search == '') {
                this.currentUser = [];
                
                return false;
            }

            if (this.model.working_group_id != null) {
                this.isUserLoading = true;
                this.searchUser(search, this);
            }
        },
        searchUser: _.debounce((search, vm) => {
            let data = http.route('team/' + vm.model.working_group_id +'/members?project_id='+vm.$route.params.id+'&get_all=1&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentUser = response.data;
                }
                vm.isUserLoading = false;
            });
        }, 500),
        updateUser(user) {
            this.model.user_id = (user != null) ? user.user_id : null;
        },
        clearSelectedUser () {
            this.selectedUser  = null;
            this.model.user_id = null;
        },
        onDrawingNoSearch(search) {
            if (search == '') {
                this.currentDrawingNo = [];
                
                return false;
            }

            this.currentDrawingNo = [];
            this.searchDrawingNo(search, this);
        },
        searchDrawingNo: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&filters[parent_drawing_id]=null&filters[not_discipline_id]='+1+'&limit=10&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentDrawingNo = [];
                    for (let i = 0; i < response.data.length; i++) {
                        if(response.data[i].drawing_number != null) {
                            vm.currentDrawingNo.push(response.data[i].drawing_number.toString());
                        }
                    }
                }
            });
        }, 500),
        onDrawingSearch(search) {
            if (search == '') {
                this.currentDrawing = [];
                
                return false;
            }

            this.isDrawingLoading = true;
            this.searchDrawing(search, this);
        },
        onItemNoSearch(search) {
            if (search == '') {
                this.currentItemNo = [];
                
                return false;
            }

            this.currentItemNo = [];
            this.searchItemNo(search, this);
        },
        searchItemNo: _.debounce((search, vm) => {
            let data = http.route('drawing?project_id=' + vm.$route.params.id + '&filters[parent_drawing_id]=null&filters[not_discipline_id]='+1+'&limit=10&search_select=' + search).get();
            data.then(response => {
                vm.currentItemNo = [];
                for (let i = 0; i < response.data.length; i++) {
                    if(response.data[i].item_number != null) {
                        vm.currentItemNo.push(response.data[i].item_number.toString());
                    }
                }
            });
        }, 500),
        searchDrawing: _.debounce((search, vm) => {
            http.route("drawing?project_id="+vm.$route.params.id+"&filters[parent_drawing_id]=null&search_select=" + search).get()
            .then(response => {
                if (response.data != false) {
                    vm.currentDrawing = response.data;
                }
                vm.isDrawingLoading = false;
            });
        }, 500),
        updateDrawing(drawing) {

        },
        filterSearch (from, compare) {
            var that = this;
            return from.filter(function(value, key) {
                return !compare.find(x => x.id == value.id);
            });
        },
        onLineSearch(search) {
            if (search == '') {
                this.currentLine = [];
                
                return false;
            }

            this.isLineLoading = true;
            this.searchLine(search, this);
        },
        searchLine: _.debounce((search, vm) => {
            let data = http.route('line?project_id='+vm.$route.params.id+'&filters[parent_line_id]=null&search_select=' + search).get();
            data.then(response => {
                if (response.data != false) {
                    vm.currentLine = vm.filterSearch(response.data, vm.getData.lineData);
                }
                vm.isLineLoading = false;
            });
        }, 500),
    }
}
</script>

<style scoped>
	select {
		-webkit-appearance:menulist-button;
		-moz-appearance:menulist-button;
	}
</style>



// WEBPACK FOOTER //
// src/components/pages/project/construction/drawings/other_drawings/other_drawings.vue